(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name crewing.directive:searchPanel
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="crewing">
     <file name="index.html">
     <search-panel></search-panel>
     </file>
     </example>
     *
     */
    angular
        .module('crewing')
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
        .directive('searchPanel', searchPanel);

    function searchPanel(applicationConstants, CrewingHelper, EventManagerService) {
        return {
            restrict: 'EA',
            scope: {
                onSearchPanelOpen: '&',
                crewTypes: '=',
                aircraftTypes: '=',
                crewBaseTypes: '=',
                crewCategory: '=',
                mgtPositions: '=',
                crewGroups: '=',
                nationalities : '=',
                crewBatchList : '=',
                lanaguages : '=',
                onSearchSchedule: '&',
                isOpenSearchPanel: '=',
                crewTypeMasterCodes : '=',
                crewOperTypes :'=',
                crewIds : '=',
                onChangeCrewType: '&',
            },
            templateUrl: 'crewing/directives/search-panel-directive.tpl.html',
            replace: false,
            controllerAs: 'searchPanel',
            bindToController: true,
            controller: ['$scope', function ($scope) {
                var vm = this;
                vm.isOpenSearchPanel = false;
                vm.model = {
                    fromDate: '',
                    toDate: '',
                    noOfDays: '',
                    crewType: '',
                    crewBase: '',
                    aircraftType: '',
                    crewGroup: '',
                    crewIds: '',
                    crewIdList : [],
                    isTrainingPattern: false,
                    isShowAllCrew: false,
                    crewCategory: '',
                    mgtPositions: '',
                    displayTimeZone: '',
                    crewTypeMaster: '',
                    selectedLanaguage: '',
                    nationality: '',
                    gender: '',
                    notShowingCrewPortal:null,
                    configShowInCrewPortal:false,
                    showIllegalOnly:false,
                    showLayoverOnly:false,
                    crewOperType:'',
                    selectedCrewId : null,
                    sortKey:'',
                    sortDirection:''
                };

                $scope.$watch('searchPanel.crewTypes',function(newVal,oldVal){
                    if(!!newVal && (newVal != oldVal)){
                        vm.model.crewTyleClone = angular.copy(vm.crewTypes);
                    }
                });

                vm.model.genderTypes = [
                    {
                        code: null,
                        name: 'All'
                    },
                    {
                        code: 'M',
                        name: 'Male'
                    },
                    {
                        code: 'F',
                        name: 'Female'
                    }
                ];

                vm.model.showInCrewPortalTypes = [
                    {
                        code: null,
                        name: 'All'
                    },
                    {
                        code: false,
                        name: 'Visible'
                    },
                    {
                        code: true,
                        name: 'Hidden'
                    }
                ];

                vm.model.defCrewOperType = [
                      {
                    	  operTypeDesc :'All',
                    	  operTypeCode :'All'
                      }
                 ];

                vm.model.orderByTypes = [
                  {
                    code: 'firstName',
                    name: 'First Name'
                  },
                  {
                    code: 'crewId',
                    name: 'Crew Id'
                  },
                  {
                    code: 'crewTypeCode',
                    name: 'Crew Type'
                  },
                  {
                    code: 'fleetExperince',
                    name: 'Fleet Experience'
                  },
                  {
                    code: 'offCount',
                    name: 'Off Count'
                  },
                  {
                    code: 'dutyDuration',
                    name: 'Duty Duration'
                  },
                  {
                    code: 'flyingDuration',
                    name: 'Flying Duration'
                  }
                ];

                vm.model.orderByDirections = [
                  {
                    code: 'ASC',
                    name: 'Ascending'
                  },
                  {
                    code: 'DESC',
                    name: 'Descending'
                  }
                ];

                EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.CREW_LIST_UPDATED, removeInvalidCrew);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.CREW_IDS_CHANGED, setSearchPanelFields);

                setDefaultSearchDays();

                vm.loadCrewList = function(){
                	 angular.element("#crewIds .multi-select input").val("");
                	 vm.onChangeCrewType({crewType :(!!vm.model.crewType && !!vm.model.crewType.crewTypeCode) ? vm.model.crewType.crewTypeCode : ""});
                };


                vm.addCrewIDs = function () {
                	if(!!!vm.model.crewIdList){
                		vm.model.crewIdList = [];
                	}
                	vm.model.crewIdList.push(vm.model.selectedCrewId);
                    var index = vm.crewIds.indexOf(vm.model.selectedCrewId);
                    if (index > -1) {
                    	vm.crewIds.splice(index, 1);
                    }
                    vm.model.selectedCrewId = null;
                };

                vm.addCommaSeparatedCrewIDs = function(){
                	if(!!vm.model.selectedCrewId) {
                		var multipleCrewIds = vm.model.selectedCrewId.replace(/\s+/g, '').split(',');
                		if(multipleCrewIds.length > 1){
                			var selectedCrewList = _.filter(vm.crewIds, function(crew){
                				return (multipleCrewIds.includes(crew.crewId)) ? true : false;
                			});
                			if(!!!vm.model.crewIdList){
                        		vm.model.crewIdList = [];
                        	}
                			Array.prototype.push.apply(vm.model.crewIdList, selectedCrewList);
                			vm.crewIds = _.filter(vm.crewIds, function(crew){
                				return (!selectedCrewList.includes(crew)) ? true : false;
                			});
                		}
                	}
                }

                function setSearchPanelFields(param){
                	if(!!param){
                		resetAllParam();
                		if(!!param.fromDate){
                			setDefaultSearchDays(param.fromDate);
                		}
                		if(!!param.crewIds){
                			vm.model.selectedCrewId = param.crewIds;
                        	vm.addCommaSeparatedCrewIDs();
                		}


                	}
                }


              function getManagementCrewPositions() {
                CrewingHelper.getManagementCrewPositions(
                  function (response) {
                    vm.model.mgtPositions = response;
                  },
                  function (error) {
                    MessageService.error(error[0]);
                  }
                );
              }

                function resetAllParam(){
                	vm.model.crewIds = '';
            		vm.model.crewIdList = [];
            		vm.model.crewType = '';
            		vm.model.crewBase = '';
            		vm.model.aircraftType = '';
            		vm.model.crewGroup = '';
            		vm.model.isTrainingPattern = false;
            		vm.model.isShowAllCrew = false;
            		vm.model.crewCategory = '';
                  vm.model.mgtPositions = '';
            		vm.model.displayTimeZone = '';
            		vm.model.crewTypeMaster = '';
            		vm.model.selectedLanaguage = '';
            		vm.model.nationality = '';
            		vm.model.gender = '';
            		vm.model.notShowingCrewPortal = null;
            		vm.model.configShowInCrewPortal = false;
            		vm.model.showIllegalOnly = false;
            		vm.model.showLayoverOnly = false;
            		vm.model.crewOperType = '';
            		vm.model.selectedCrewId = null;
                }

                function isRequiredToMultiSelect(crewList){

                }

                vm.removeCrewIDs = function (selectedCrewId, index) {
                	vm.crewIds.push(selectedCrewId);
                    delete vm.model.crewIdList[index];
                };

                function removeInvalidCrew(){
                	vm.model.crewIdList = _.find(vm.model.crewIdList, function(crew){
        				return vm.crewIds.contains(crew);
        			});
                }

                vm.onSearchBarClick = function () {
                    vm.isOpenSearchPanel = !vm.isOpenSearchPanel;
                    vm.onSearchPanelOpen();
                };

                vm.onSearchBarClick();

                vm.onSearchClick = function () {
                    if (vm.form.$valid) {
                    	var commaSeperatedCrewIds = "";
                    	if(Array.isArray(vm.model.crewIdList)) {
                    		angular.forEach(vm.model.crewIdList, function(crew) {
                    			if(crew.crewId != undefined){
                    				commaSeperatedCrewIds += crew.crewId + ",";
                    			}
                        	})
                    	}
                    	if(commaSeperatedCrewIds != "") {
                    		commaSeperatedCrewIds = commaSeperatedCrewIds.substring(0, commaSeperatedCrewIds.length-1);
                    	}
                    	vm.model.crewIds = commaSeperatedCrewIds;
                        vm.onSearchSchedule({'searchParam': vm.model});
                    }
                };

                vm.onFromDateChange = function () {
                    var moEnd = moment(vm.model.fromDate, applicationConstants.SETTINGS.DATE_FORMAT).endOf("month");
                    vm.model.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    calculateDateDiff();
                };

                vm.onToDateChange = function () {
                    calculateDateDiff();
                };

                vm.onCrewTypeMasterSelected = function(){
                    vm.model.crewType = null;
                    if(!!vm.model.crewTypeMaster){
                        vm.model.crewTyleClone = _.where(vm.crewTypes,{crewTypeMasterCode : vm.model.crewTypeMaster.code})
                    }else{
                        vm.model.crewTyleClone = angular.copy(vm.crewTypes);
                    }
                };

                //initial crew list Loading
                (function(){
                	vm.loadCrewList();
                })();

                function setDefaultSearchDays(relDate) {
                	var date = !!relDate ? moment(relDate, applicationConstants.SETTINGS.DATE_FORMAT) : moment();
                    var moStart = date.clone().startOf("month");
                    var moEnd = date.clone().endOf("month");
                    vm.model.fromDate = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    vm.model.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    vm.model.gender =  vm.model.genderTypes[0];
                    vm.model.crewOperType = vm.model.defCrewOperType[0];
                    calculateDateDiff();
                    CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                        var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                        vm.model.configShowInCrewPortal = appParamsEnable;
                    });
                }

                vm.loadMatchingIndex =function (viewValue) {
                  if(viewValue !== " ") {
                    angular.forEach(vm.nationalities, function(nat) {
                      nat.matchingIndex = nat.description.toLowerCase().indexOf(viewValue.toLowerCase());
                    })
                  }

              };

                function calculateDateDiff() {
                    if (!!vm.model.fromDate && !!vm.model.toDate) {
                        var moFrom = moment(vm.model.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                        var moTo = moment(vm.model.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
                        vm.model.noOfDays = moTo.diff(moFrom, 'd') + 1;
                    }
                }

            }],
            link: function (scope, element, attrs) {

            }
        };
    }
}());
